// frontend/src/components/MessageBox.js
// Componente de caja de mensajes personalizado (reemplazo para alert/confirm).

import React from 'react';
import { useUIStore } from '../store/uiStore'; // Importa el store de UI
import { XMarkIcon } from '@heroicons/react/24/solid'; // Icono para cerrar el mensaje (usando lucide-react, pero para este ejemplo, usaremos una alternativa si no está disponible)
// Si @heroicons/react no está disponible, se puede usar SVG en línea o un icono de Font Awesome si se prefiere.

/**
 * @component MessageBox
 * @description Muestra mensajes temporales (éxito, error, info) en la parte superior de la pantalla.
 * Utiliza el `useUIStore` para controlar su visibilidad y contenido.
 */
function MessageBox() {
  const { showMessage, messageText, messageType, hideMessage } = useUIStore();

  if (!showMessage) {
    return null;
  }

  const baseClasses = "fixed top-4 left-1/2 -translate-x-1/2 p-4 rounded-lg shadow-lg flex items-center justify-between z-50 transition-opacity duration-300";
  let typeClasses = '';

  switch (messageType) {
    case 'success':
      typeClasses = 'bg-green-500 text-white';
      break;
    case 'error':
      typeClasses = 'bg-red-500 text-white';
      break;
    case 'info':
    default:
      typeClasses = 'bg-blue-500 text-white';
      break;
  }

  // Fallback para XMarkIcon si heroicons/react no funciona en el entorno
  const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  );

  return (
    <div className={`${baseClasses} ${typeClasses}`}>
      <p className="mr-4">{messageText}</p>
      <button onClick={hideMessage} className="ml-2 p-1 rounded-full hover:bg-white hover:bg-opacity-20 focus:outline-none focus:ring-2 focus:ring-white">
        {/* Intenta renderizar XMarkIcon si está disponible, si no, usa el SVG fallback */}
        {typeof XMarkIcon !== 'undefined' ? <XMarkIcon className="h-5 w-5" /> : <CloseIcon />}
        <span className="sr-only">Cerrar mensaje</span>
      </button>
    </div>
  );
}

export default MessageBox;
